import { template as template_f62bc5fd872f4f2198fc275b9586a7ee } from "@ember/template-compiler";
import PendingInsuranceInfoBanner from './pending-insurance-info-banner';
import RejectedRequests from './rejected-requests';
import styles from './submission-notifications.module.scss';
export default template_f62bc5fd872f4f2198fc275b9586a7ee(`
  <div class={{styles.component}}>
    {{#if @pendingInsuranceRequests}}
      <PendingInsuranceInfoBanner @pendingInsuranceInfoCount={{@pendingInsuranceRequests.length}} />
    {{/if}}
    {{#if @rejectedInsuranceRequests}}
      <RejectedRequests @rejectedInsuranceRequests={{@rejectedInsuranceRequests}} />
    {{/if}}
  </div>
`, {
    eval () {
        return eval(arguments[0]);
    }
});
